var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64.116 23.753 h 13.706 c 1.77 0 3.205 1.435 3.205 3.205 v 39.287 H 8.809 V 26.958 c 0 -1.77 1.435 -3.205 3.205 -3.205 h 6.664",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(179,218,254)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.32,
    y: 74.92,
    rx: 0,
    ry: 0,
    width: 17.35,
    height: 9.46,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,240,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.904 74.922 H 12.096 c -1.77 0 -3.205 -1.435 -3.205 -3.205 v -5.333 h 72.218 v 5.333 C 81.109 73.487 79.674 74.922 77.904 74.922 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,240,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.868 88.999 H 30.132 v -1.323 c 0 -1.818 1.473 -3.291 3.291 -3.291 h 23.153 c 1.818 0 3.291 1.473 3.291 3.291 V 88.999 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,240,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.823 35.29 l -0.034 1.41 c 0 0.509 -0.102 0.999 -0.289 1.452 l -8.795 3.486 c -2.868 0.483 -4.952 2.786 -4.952 5.473 v 19.273 h 20.171 h 20.171 V 47.112 c 0 -2.687 -2.084 -4.99 -4.952 -5.473 l -8.805 -3.486 l -0.311 -2.863 H 39.823 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(63,110,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30.7,41.64 39.5,38.15 45.92,50.73 30.7,41.64 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(240,114,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.13,41.64 52.34,38.15 45.92,50.73 61.13,41.64 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(240,114,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.34,38.15 45.92,50.73 39.5,38.15 39.5,35.29 52.34,35.29 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,190,155)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.33 26.672 c -0.424 5.069 -3.763 9.427 -8.547 11.156 l 0 0 c -0.602 0.217 -1.232 0.325 -1.863 0.324 h 0.015 c -0.63 0.001 -1.261 -0.107 -1.863 -0.324 l 0 0 c -4.784 -1.729 -8.123 -6.086 -8.547 -11.156 l -0.404 -11.095 c 7.209 -1.51 14.418 -1.51 21.626 0 L 56.32 26.672",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,190,155)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.955 29.069 c -1.955 -0.568 -3.383 -2.373 -3.383 -4.511 v -2.179 c 0 -0.728 0.59 -1.318 1.318 -1.318 h 1.297 L 35.955 29.069 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,190,155)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.709 21.061 h 1.247 c 0.728 0 1.318 0.59 1.318 1.318 v 2.177 c 0 2.139 -1.429 3.944 -3.384 4.512 L 56.709 21.061 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,190,155)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.125 23.031 c -0.156 0 -0.314 -0.036 -0.461 -0.113 c -1.046 -0.545 -2.02 -0.545 -3.066 0 c -0.489 0.255 -1.093 0.065 -1.349 -0.424 c -0.255 -0.49 -0.065 -1.094 0.424 -1.349 c 1.63 -0.851 3.283 -0.852 4.915 0 c 0.49 0.255 0.68 0.859 0.424 1.349 C 44.833 22.835 44.485 23.031 44.125 23.031 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(7,42,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.71 23.031 c -0.155 0 -0.313 -0.036 -0.462 -0.113 c -1.045 -0.546 -2.019 -0.546 -3.064 0 c -0.494 0.257 -1.094 0.065 -1.35 -0.424 c -0.255 -0.49 -0.065 -1.094 0.424 -1.349 c 1.631 -0.851 3.285 -0.851 4.916 0 c 0.489 0.255 0.679 0.859 0.424 1.349 C 52.419 22.835 52.07 23.031 51.71 23.031 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(7,42,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.501 29.671 c -3.052 4.011 -6.104 4.039 -9.155 0 H 50.501 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.915 33.69 c -0.002 0 -0.005 0 -0.007 0 c -1.847 -0.003 -3.65 -1.152 -5.36 -3.416 c -0.229 -0.303 -0.267 -0.709 -0.097 -1.049 c 0.169 -0.339 0.516 -0.554 0.895 -0.554 h 9.155 c 0.38 0 0.728 0.215 0.895 0.556 c 0.169 0.341 0.131 0.748 -0.1 1.05 C 49.573 32.541 47.763 33.69 45.915 33.69 z M 43.611 30.671 c 0.792 0.676 1.561 1.018 2.3 1.019 c 0.001 0 0.002 0 0.004 0 c 0.74 0 1.514 -0.342 2.31 -1.019 H 43.611 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(7,42,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.122 11.491 l 0 4.086 c 7.209 -1.51 14.418 -1.51 21.626 0 v -4.094 l 9.107 -2.992 c 0.614 -0.202 0.614 -1.07 0 -1.271 L 47.887 1.316 c -1.276 -0.419 -2.652 -0.419 -3.928 0 L 25.99 7.22 c -0.614 0.202 -0.614 1.07 0 1.271 L 35.122 11.491",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(63,110,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.376 25.397 h -3.692 v -5.785 c 0 -1.019 0.826 -1.846 1.846 -1.846 h 0 c 1.019 0 1.846 0.826 1.846 1.846 V 25.397 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,208,112)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.725 71.653 h -5.449 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 5.449 c 0.553 0 1 0.447 1 1 S 48.277 71.653 47.725 71.653 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(7,42,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.904 22.892 H 64.198 c -0.553 0 -1 0.448 -1 1 s 0.447 1 1 1 h 13.707 c 1.216 0 2.205 0.989 2.205 2.205 v 38.287 H 67.093 V 47.111 c 0 -3.143 -2.383 -5.832 -5.68 -6.436 l -8.254 -3.272 c -0.061 -0.232 -0.102 -0.471 -0.102 -0.726 l -0.022 -0.965 c 1.689 -1.618 2.964 -3.642 3.68 -5.893 c 2.117 -0.864 3.559 -2.942 3.559 -5.263 v -2.177 c 0 -1.278 -1.04 -2.318 -2.318 -2.318 h -0.38 l 0.172 -4.445 c 0 -0.007 -0.003 -0.013 -0.003 -0.02 c 0 -0.007 0.004 -0.012 0.004 -0.019 v -3.37 l 8.42 -2.766 c 0.687 -0.226 1.147 -0.863 1.147 -1.586 s -0.461 -1.36 -1.147 -1.586 L 48.199 0.366 c -1.488 -0.49 -3.063 -0.49 -4.552 0 L 25.678 6.269 c -0.686 0.226 -1.147 0.863 -1.147 1.586 v 9.102 c -1.076 0.407 -1.846 1.439 -1.846 2.655 v 5.784 c 0 0.552 0.448 1 1 1 h 3.692 c 0.552 0 1 -0.448 1 -1 v -5.784 c 0 -1.216 -0.77 -2.249 -1.846 -2.655 V 9.721 l 7.592 2.494 v 3.362 c 0 0.006 0.003 0.011 0.003 0.016 c 0 0.007 -0.003 0.013 -0.003 0.02 l 0.162 4.448 H 33.89 c -1.278 0 -2.318 1.04 -2.318 2.318 v 2.179 c 0 2.326 1.448 4.406 3.571 5.267 c 0.715 2.245 1.986 4.265 3.67 5.88 L 38.789 36.7 c 0 0.235 -0.029 0.467 -0.087 0.693 l -5.33 2.113 l -2.941 1.166 c -3.297 0.604 -5.678 3.296 -5.678 6.44 v 18.273 H 9.891 V 27.097 c 0 -1.216 0.989 -2.205 2.205 -2.205 h 6.664 c 0.552 0 1 -0.448 1 -1 s -0.448 -1 -1 -1 h -6.664 c -2.319 0 -4.205 1.886 -4.205 4.205 v 39.287 v 5.333 c 0 2.318 1.886 4.205 4.205 4.205 h 23.227 v 7.463 h -1.9 c -2.366 0 -4.291 1.925 -4.291 4.291 v 1.323 c 0 0.553 0.448 1 1 1 h 29.735 c 0.553 0 1 -0.447 1 -1 v -1.323 c 0 -2.366 -1.925 -4.291 -4.291 -4.291 h -1.9 v -7.463 h 23.228 c 2.318 0 4.205 -1.887 4.205 -4.205 v -5.333 V 27.097 C 82.109 24.778 80.223 22.892 77.904 22.892 z M 65.093 47.111 v 18.273 h -6.301 c 0.005 -2.374 0.003 -8.052 0.001 -9.092 c -0.001 -0.552 -0.448 -0.999 -1 -0.999 h -0.001 c -0.553 0.001 -1 0.449 -0.999 1.001 c 0.002 1.873 0.003 6.95 -0.001 9.09 h -9.875 V 51.296 l 14.377 -8.59 C 63.51 43.218 65.093 45.015 65.093 47.111 z M 48.389 48.088 l 4.426 -8.671 l 6.062 2.404 L 48.389 48.088 z M 57.956 22.061 c 0.176 0 0.318 0.143 0.318 0.318 v 2.177 c 0 0.944 -0.373 1.823 -0.983 2.491 c 0.01 -0.098 0.027 -0.193 0.035 -0.291 c 0.006 -0.063 0.005 -0.125 -0.001 -0.186 l 0.174 -4.51 H 57.956 z M 26.376 24.397 h -1.692 v -4.785 c 0 -0.467 0.379 -0.846 0.846 -0.846 c 0.466 0 0.846 0.379 0.846 0.846 V 24.397 z M 27.259 7.855 l 17.013 -5.589 c 1.08 -0.355 2.223 -0.355 3.303 0 l 17.013 5.589 l -6.839 2.247 V 9.118 c 0 -0.034 -0.016 -0.063 -0.019 -0.096 c -0.007 -0.068 -0.019 -0.13 -0.039 -0.194 c -0.019 -0.062 -0.041 -0.12 -0.072 -0.176 c -0.03 -0.056 -0.064 -0.105 -0.104 -0.155 c -0.041 -0.051 -0.083 -0.095 -0.133 -0.137 c -0.048 -0.04 -0.099 -0.073 -0.154 -0.104 c -0.059 -0.033 -0.118 -0.058 -0.184 -0.079 c -0.032 -0.01 -0.056 -0.031 -0.089 -0.038 c -1.93 -0.404 -3.886 -0.706 -5.813 -0.896 c -0.577 -0.061 -1.04 0.348 -1.094 0.897 c -0.055 0.549 0.348 1.039 0.896 1.093 c 1.593 0.158 3.205 0.409 4.806 0.719 v 4.426 c -6.518 -1.213 -13.108 -1.213 -19.626 0 V 9.951 c 3.258 -0.631 6.55 -0.965 9.8 -0.965 c 0.553 0 1 -0.448 1 -1 c 0 -0.552 -0.448 -1 -1 -1 c -3.652 0 -7.355 0.389 -11.006 1.154 c -0.032 0.007 -0.057 0.028 -0.088 0.038 c -0.067 0.021 -0.127 0.047 -0.186 0.08 C 34.588 8.288 34.538 8.32 34.49 8.36 c -0.05 0.042 -0.092 0.086 -0.133 0.137 c -0.04 0.05 -0.075 0.099 -0.105 0.156 c -0.03 0.056 -0.052 0.113 -0.071 0.174 c -0.02 0.064 -0.033 0.127 -0.039 0.195 c -0.003 0.033 -0.019 0.062 -0.019 0.095 v 0.992 L 27.259 7.855 z M 33.572 24.558 v -2.179 c 0 -0.176 0.143 -0.318 0.318 -0.318 h 0.468 l 0.171 4.695 c 0.009 0.103 0.026 0.203 0.037 0.305 C 33.949 26.392 33.572 25.508 33.572 24.558 z M 36.526 26.636 L 36.153 16.39 c 6.494 -1.253 13.067 -1.254 19.564 0 l -0.395 10.244 c -0.001 0.03 -0.001 0.06 0 0.09 c -0.437 4.608 -3.517 8.588 -7.879 10.164 c -0.484 0.176 -0.992 0.265 -1.509 0.265 c -0.003 0.001 -0.007 0 -0.01 0 c -0.002 0 -0.004 0 -0.006 0 c -0.514 0 -1.02 -0.09 -1.503 -0.265 C 40.01 35.297 36.913 31.254 36.526 26.636 z M 43.733 38.768 c 0.704 0.255 1.44 0.384 2.19 0.384 c 0.002 0 0.006 -0.001 0.01 0 c 0.749 0 1.487 -0.129 2.19 -0.384 c 1.068 -0.386 2.066 -0.902 2.987 -1.516 c 0.031 0.267 0.085 0.529 0.161 0.788 l -5.353 10.488 l -5.347 -10.477 c 0.079 -0.267 0.134 -0.535 0.165 -0.806 C 41.66 37.863 42.661 38.381 43.733 38.768 z M 39.023 39.417 l 4.425 8.67 l -10.488 -6.267 L 39.023 39.417 z M 26.753 47.111 c 0 -2.094 1.58 -3.89 3.792 -4.404 l 14.374 8.588 v 14.089 h -9.907 c -0.004 -2.127 -0.003 -7.162 -0.001 -9.09 c 0.001 -0.552 -0.446 -1 -0.999 -1.001 c 0 0 -0.001 0 -0.001 0 c -0.552 0 -0.999 0.447 -1 0.999 c -0.002 1.17 -0.004 6.746 0.001 9.092 h -6.258 V 47.111 z M 58.868 87.675 v 0.323 H 31.132 v -0.323 c 0 -1.264 1.028 -2.291 2.291 -2.291 h 2.9 h 17.353 h 2.9 C 57.84 85.384 58.868 86.412 58.868 87.675 z M 52.677 83.385 H 37.323 v -7.463 h 15.353 V 83.385 z M 80.109 71.717 c 0 1.216 -0.989 2.205 -2.205 2.205 H 53.676 H 36.324 H 12.096 c -1.216 0 -2.205 -0.989 -2.205 -2.205 v -4.333 h 15.861 h 40.341 h 14.016 V 71.717 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(7,42,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.6faa620668cc7629b97402fb7588d714.svg";
export { ForwardRef as ReactComponent };